import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl } from '../../../../Containers/Config/index.js';
import { DOWNLOAD_USER_LOGS, DOWNLOAD_USER_LOGS_SUCCESS, DOWNLOAD_USER_LOGS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* downloadUserLogs({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v1/adib-download`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...payload?.headers,
        'X-Requested-By': 'ADIB_ADMIN',
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      console.log('User 1 Check', response?.data?.message);
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: DOWNLOAD_USER_LOGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DOWNLOAD_USER_LOGS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_USER_LOGS_ERROR, payload: error });
  }
}

export function* watchDownloadUserLogs() {
  yield takeEvery(DOWNLOAD_USER_LOGS, downloadUserLogs);
}

function* downloadUserLogsSaga() {
  yield all([fork(watchDownloadUserLogs)]);
}

export default downloadUserLogsSaga;
